import { Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

import { Category, Document } from 'interfaces/documents';
import { Delete } from './ItemActions/Delete';
import { Copy } from './ItemActions/Copy';
import { Move } from './ItemActions/Move';
import { Rename } from './ItemActions/Rename';
import { Versions } from './ItemActions/Versions';
import { Sharing } from './ItemActions/Sharing';
import { History } from './ItemActions/History';
import { PermissionCombinationType, useAccess } from 'smx-components';

const ItemActionList = ({
    fetchData,
    row,
    shared,
}: {
    fetchData: () => void;
    row: Category | Document;
    shared?: boolean;
}) => {
    const isProjectDocument = row.is_project_document;
    const createPermissions: PermissionCombinationType[] = isProjectDocument
        ? ['files.project.create']
        : ['files.all.create'];
    const editPermissions: PermissionCombinationType[] = isProjectDocument
        ? ['files.project.edit']
        : ['files.all.edit'];
    const managePermissions: PermissionCombinationType[] = isProjectDocument
        ? ['files.project.manage']
        : ['files.all.manage'];
    const canCreate = useAccess(createPermissions);
    const canEdit =
        useAccess(editPermissions) && (row.access === 'manager' || row.access === 'editor' || row.access === null);
    const canManage = useAccess(managePermissions) && (row.access === 'manager' || row.access === null);

    const copyBtn = Copy(row, fetchData);
    const deleteBtn = Delete(row, fetchData);
    const historyBtn = History(row);
    const moveBtn = Move(row, fetchData);
    const renameBtn = Rename(row, fetchData);
    const sharingBtn = Sharing(row, fetchData);
    const versionBtn = Versions(row as Document);

    if ((row as Category).is_locked) return <></>;

    const items = [];
    if (row.type === 'document') {
        items.push(versionBtn);
        if (canCreate) {
            items.push(copyBtn);
        }
    }
    if (canEdit) {
        items.push(renameBtn);
    }
    if (canManage) {
        items.push(sharingBtn, deleteBtn, historyBtn, moveBtn);
    }

    return (
        <>
            {items.length > 0 && (
                <Dropdown menu={{ items }}>
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                        }}
                    >
                        <MoreOutlined />
                    </a>
                </Dropdown>
            )}
        </>
    );
};

export default ItemActionList;
